import ResetPasswordComponent from "../components/reset-password/reset-password.component";


const ResetPassword = () => {

    return (
        <>
            <ResetPasswordComponent></ResetPasswordComponent>
        </>
    )

}

export default ResetPassword;